import { Divider } from "@material-ui/core";
import React from "react";

export const KyrDivider = () => (
    <Divider style={{ marginTop: 15, marginBottom: 15, padding: 1 }} />
)